import { create } from "zustand";

import {
  getLastMonthRange,
  type DateRange,
} from "../components/reports/ReportDateRangePicker";
import type {
  BillingReportAccountType,
  BillingReportDateBasis,
} from "../services/reports.service";
import { DEFAULT_BILLING_REPORT_ACCOUNT_TYPE } from "../services/reports.service";

interface CptFrequencyFilters {
  dateRange: DateRange;
  dateBasis: BillingReportDateBasis;
  accountType: BillingReportAccountType;
  pathologistId: string | null;
  practiceId: string | null;
  physicianId: string | null;
  surgeryCenterLabId: string | null;
  prefixId: string | null;
  billingScenarioId: string | null;
}

interface CptFrequencyReportState extends CptFrequencyFilters {
  page: number;
  updateFilters: (values: Partial<CptFrequencyFilters>) => void;
  setPage: (page: number) => void;
}

export const useCptFrequencyReportStore = create<CptFrequencyReportState>(
  (set) => ({
    dateRange: getLastMonthRange(),
    dateBasis: "first_reported",
    accountType: DEFAULT_BILLING_REPORT_ACCOUNT_TYPE,
    pathologistId: null,
    practiceId: null,
    physicianId: null,
    surgeryCenterLabId: null,
    prefixId: null,
    billingScenarioId: null,
    page: 1,
    updateFilters: (values) => set({ ...values, page: 1 }),
    setPage: (page) => set({ page }),
  })
);
